import React from 'react';
import DataViewers from "../DataViewers.js";
import DataViewerCardView from "./DataViewerCardView.js";
import DataViewerCardModel from "./DataViewerCardModel.js";
import DataViewerCardMenu from "./DataViewerCardMenu.js";
export default class DataViewerCardPlugin {
  constructor() {
    this.type = DataViewerCardModel.TYPE;
    this.viewer = DataViewerCardView;
    this.isInternal = true; // this card is not directly addable.
    this.model = DataViewerCardModel;
  }
  getDataViewer(model, dc) {
    return DataViewers.get(model?.dataViewer);
  }
  getDataViewerValue(m, fName, pName, dc) {
    const dv = this.getDataViewer(m, dc);
    if (dv == null) {
      return null;
    }
    return typeof dv[fName] === 'function' ? dv[fName](m, dc) : pName && dv[pName];
  }
  menuEditor = props => {
    const {
      value: model,
      sharedProps
    } = props;
    const dv = sharedProps?.dataViewers?.getByType(model?.dataViewer?.type);
    let subMenu = null;
    if (dv && dv.getCardMenuEditor) {
      subMenu = dv.getCardMenuEditor(props);
    }
    return /*#__PURE__*/React.createElement(DataViewerCardMenu, subMenu ? {
      ...props,
      subMenu
    } : props);
  };
  footerEditor = (props, dc) => {
    const {
      value: model,
      sharedProps
    } = props;
    const dv = sharedProps?.dataViewers?.getByType(model?.dataViewer?.type);
    if (dv && dv.getCardFooterEditor) {
      return dv.getCardFooterEditor(props);
    }
    return null;
  };
  getCardTitle = (m, dc) => {
    return this.getDataViewerValue(m, 'getCardTitle', 'name', dc);
  };
  getCardIcon = (m, dc) => {
    return null; // this.getDataViewerValue( m, 'getCardIcon', 'icon', dc ) 
  };
  getRequired = (m, factory, dc) => {
    return this.getDataViewerValue(m, 'getCardRequired', null, dc) || [];
  };
}